var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({ backgroundImage: _setup.backgroundImage }),attrs:{"id":"survey-layout"}},[_c(_setup.AzLoader,{staticClass:"loading",attrs:{"loading":_setup.isWaiting('survey')}}),_vm._v(" "),_c('div',{staticClass:"survey"},[_c('div',{ref:"tripettoRef",staticClass:"survey__tripetto",attrs:{"id":"tripetto"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }